import { useState } from "react";
import { faqs } from "@/mocks/content";

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-50 py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid gap-10 lg:grid-cols-[minmax(0,380px)_1fr] lg:gap-16">
          {/* Cabeçalho */}
          <aside className="reveal lg:sticky lg:top-28 lg:self-start">
            <span className="mb-4 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-primary-600">
              <span className="h-px w-6 bg-current" />
              Perguntas frequentes
            </span>
            <h2 className="font-heading text-3xl font-bold leading-[1.1] tracking-tight text-foreground-950 md:text-5xl">
              Ficou alguma dúvida?
            </h2>
            <p className="mt-5 max-w-sm text-base leading-relaxed text-foreground-600">
              Tudo o que você precisa saber antes de dar o play no seu cardápio.
            </p>
          </aside>

          {/* Lista de perguntas */}
          <div className="flex flex-col gap-3">
            {faqs.map((item, i) => {
              const isOpen = open === i;
              return (
                <div
                  key={item.question}
                  className="reveal overflow-hidden rounded-xl border border-background-200 bg-background-100"
                  style={{ transitionDelay: `${i * 40}ms` }}
                >
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? null : i)}
                    aria-expanded={isOpen}
                    aria-controls={`faq-answer-${i}`}
                    className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-5 text-left md:px-6"
                  >
                    <span className="font-heading text-base font-semibold leading-snug text-foreground-950 md:text-lg">
                      {item.question}
                    </span>
                    <i
                      className={`shrink-0 text-xl text-primary-600 transition-transform duration-300 ${
                        isOpen ? "ri-subtract-line rotate-180" : "ri-add-line"
                      }`}
                      aria-hidden="true"
                    />
                  </button>

                  <div
                    id={`faq-answer-${i}`}
                    className={`grid transition-all duration-300 ease-out ${
                      isOpen
                        ? "grid-rows-[1fr] opacity-100"
                        : "grid-rows-[0fr] opacity-0"
                    }`}
                  >
                    <div className="overflow-hidden">
                      <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600 md:px-6 md:pb-6 md:text-base">
                        {item.answer}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}